import { default as indexrHTEgRJpVAMeta } from "E:/W2/MedCAT_2026/MedCAT.Cms/pages/account/index.vue?macro=true";
import { default as loginsJ6UpPKivxMeta } from "E:/W2/MedCAT_2026/MedCAT.Cms/pages/account/login.vue?macro=true";
import { default as settingsbq4wAt3PeeMeta } from "E:/W2/MedCAT_2026/MedCAT.Cms/pages/account/settings.vue?macro=true";
import { default as indexkUP3nD91YzMeta } from "E:/W2/MedCAT_2026/MedCAT.Cms/pages/activity-log/index.vue?macro=true";
import { default as _91id_93suVH3JdiHSMeta } from "E:/W2/MedCAT_2026/MedCAT.Cms/pages/admin/form-config/[id].vue?macro=true";
import { default as indexETZx13UsxPMeta } from "E:/W2/MedCAT_2026/MedCAT.Cms/pages/admin/form-config/index.vue?macro=true";
import { default as indexVQfySp04NZMeta } from "E:/W2/MedCAT_2026/MedCAT.Cms/pages/app/index.vue?macro=true";
import { default as builderfbSIuX1dLjMeta } from "E:/W2/MedCAT_2026/MedCAT.Cms/pages/builder.vue?macro=true";
import { default as _91code_93grZLuXOcZSMeta } from "E:/W2/MedCAT_2026/MedCAT.Cms/pages/category/[code].vue?macro=true";
import { default as indexY5A6T90tt5Meta } from "E:/W2/MedCAT_2026/MedCAT.Cms/pages/chat/index.vue?macro=true";
import { default as indexNRdQglQVRYMeta } from "E:/W2/MedCAT_2026/MedCAT.Cms/pages/company/index.vue?macro=true";
import { default as _91id_93UBNjqDrkVwMeta } from "E:/W2/MedCAT_2026/MedCAT.Cms/pages/contract/[id].vue?macro=true";
import { default as _91id_93gUquwCbBGsMeta } from "E:/W2/MedCAT_2026/MedCAT.Cms/pages/contract/document/[id].vue?macro=true";
import { default as indexCCogMnrTKMMeta } from "E:/W2/MedCAT_2026/MedCAT.Cms/pages/contract/index.vue?macro=true";
import { default as indexFv3GCAtpriMeta } from "E:/W2/MedCAT_2026/MedCAT.Cms/pages/customer/index.vue?macro=true";
import { default as prescription_45dynamicNQT5rP4uSxMeta } from "E:/W2/MedCAT_2026/MedCAT.Cms/pages/demo/prescription-dynamic.vue?macro=true";
import { default as indexIUq9ZINVfxMeta } from "E:/W2/MedCAT_2026/MedCAT.Cms/pages/document-pending/index.vue?macro=true";
import { default as indexIJdKPfu1DlMeta } from "E:/W2/MedCAT_2026/MedCAT.Cms/pages/documents/index.vue?macro=true";
import { default as indexVXgfypoOe9Meta } from "E:/W2/MedCAT_2026/MedCAT.Cms/pages/facility/index.vue?macro=true";
import { default as indexxXmrObzfJ5Meta } from "E:/W2/MedCAT_2026/MedCAT.Cms/pages/index.vue?macro=true";
import { default as indexavlfLdZGoYMeta } from "E:/W2/MedCAT_2026/MedCAT.Cms/pages/original-document/index.vue?macro=true";
import { default as _91id_930CEbsQXQizMeta } from "E:/W2/MedCAT_2026/MedCAT.Cms/pages/payment-request/csyt/[id].vue?macro=true";
import { default as index2m6O0oYpUuMeta } from "E:/W2/MedCAT_2026/MedCAT.Cms/pages/payment-request/csyt/index.vue?macro=true";
import { default as _91id_93Q98aufKR0XMeta } from "E:/W2/MedCAT_2026/MedCAT.Cms/pages/payment-request/ctbh/[id].vue?macro=true";
import { default as indexf72CTmq3agMeta } from "E:/W2/MedCAT_2026/MedCAT.Cms/pages/payment-request/ctbh/index.vue?macro=true";
import { default as index8voS5OdKz1Meta } from "E:/W2/MedCAT_2026/MedCAT.Cms/pages/payment-request/index.vue?macro=true";
import { default as index0LzBiOxl7vMeta } from "E:/W2/MedCAT_2026/MedCAT.Cms/pages/role/index.vue?macro=true";
import { default as indexP8ftcLjwgHMeta } from "E:/W2/MedCAT_2026/MedCAT.Cms/pages/system-config/index.vue?macro=true";
import { default as file_45manageryJuNGiAmKmMeta } from "E:/W2/MedCAT_2026/MedCAT.Cms/pages/test/file-manager.vue?macro=true";
import { default as file_45viewer3XDVZD1T4mMeta } from "E:/W2/MedCAT_2026/MedCAT.Cms/pages/test/file-viewer.vue?macro=true";
import { default as pdf2imaget0rEU9Ac6ZMeta } from "E:/W2/MedCAT_2026/MedCAT.Cms/pages/test/pdf2image.vue?macro=true";
import { default as testl67GYZt0DaMeta } from "E:/W2/MedCAT_2026/MedCAT.Cms/pages/test.vue?macro=true";
import { default as test222Xh1ONBs6Meta } from "E:/W2/MedCAT_2026/MedCAT.Cms/pages/test2.vue?macro=true";
import { default as _91id_93I2VgFn1729Meta } from "E:/W2/MedCAT_2026/MedCAT.Cms/pages/user-report/[id].vue?macro=true";
import { default as indexIpXlCMA5v9Meta } from "E:/W2/MedCAT_2026/MedCAT.Cms/pages/user-report/index.vue?macro=true";
export default [
  {
    name: "account___vi",
    path: "/account",
    component: () => import("E:/W2/MedCAT_2026/MedCAT.Cms/pages/account/index.vue")
  },
  {
    name: "account___en",
    path: "/en/account",
    component: () => import("E:/W2/MedCAT_2026/MedCAT.Cms/pages/account/index.vue")
  },
  {
    name: "account-login___vi",
    path: "/account/login",
    meta: loginsJ6UpPKivxMeta || {},
    component: () => import("E:/W2/MedCAT_2026/MedCAT.Cms/pages/account/login.vue")
  },
  {
    name: "account-login___en",
    path: "/en/account/login",
    meta: loginsJ6UpPKivxMeta || {},
    component: () => import("E:/W2/MedCAT_2026/MedCAT.Cms/pages/account/login.vue")
  },
  {
    name: "account-settings___vi",
    path: "/account/settings",
    component: () => import("E:/W2/MedCAT_2026/MedCAT.Cms/pages/account/settings.vue")
  },
  {
    name: "account-settings___en",
    path: "/en/account/settings",
    component: () => import("E:/W2/MedCAT_2026/MedCAT.Cms/pages/account/settings.vue")
  },
  {
    name: "activity-log___vi",
    path: "/activity-log",
    component: () => import("E:/W2/MedCAT_2026/MedCAT.Cms/pages/activity-log/index.vue")
  },
  {
    name: "activity-log___en",
    path: "/en/activity-log",
    component: () => import("E:/W2/MedCAT_2026/MedCAT.Cms/pages/activity-log/index.vue")
  },
  {
    name: "admin-form-config-id___vi",
    path: "/admin/form-config/:id()",
    component: () => import("E:/W2/MedCAT_2026/MedCAT.Cms/pages/admin/form-config/[id].vue")
  },
  {
    name: "admin-form-config-id___en",
    path: "/en/admin/form-config/:id()",
    component: () => import("E:/W2/MedCAT_2026/MedCAT.Cms/pages/admin/form-config/[id].vue")
  },
  {
    name: "admin-form-config___vi",
    path: "/admin/form-config",
    component: () => import("E:/W2/MedCAT_2026/MedCAT.Cms/pages/admin/form-config/index.vue")
  },
  {
    name: "admin-form-config___en",
    path: "/en/admin/form-config",
    component: () => import("E:/W2/MedCAT_2026/MedCAT.Cms/pages/admin/form-config/index.vue")
  },
  {
    name: "app___vi",
    path: "/app",
    meta: indexVQfySp04NZMeta || {},
    component: () => import("E:/W2/MedCAT_2026/MedCAT.Cms/pages/app/index.vue")
  },
  {
    name: "app___en",
    path: "/en/app",
    meta: indexVQfySp04NZMeta || {},
    component: () => import("E:/W2/MedCAT_2026/MedCAT.Cms/pages/app/index.vue")
  },
  {
    name: "builder___vi",
    path: "/builder",
    component: () => import("E:/W2/MedCAT_2026/MedCAT.Cms/pages/builder.vue")
  },
  {
    name: "builder___en",
    path: "/en/builder",
    component: () => import("E:/W2/MedCAT_2026/MedCAT.Cms/pages/builder.vue")
  },
  {
    name: "category-code___vi",
    path: "/category/:code()",
    component: () => import("E:/W2/MedCAT_2026/MedCAT.Cms/pages/category/[code].vue")
  },
  {
    name: "category-code___en",
    path: "/en/category/:code()",
    component: () => import("E:/W2/MedCAT_2026/MedCAT.Cms/pages/category/[code].vue")
  },
  {
    name: "chat___vi",
    path: "/chat",
    component: () => import("E:/W2/MedCAT_2026/MedCAT.Cms/pages/chat/index.vue")
  },
  {
    name: "chat___en",
    path: "/en/chat",
    component: () => import("E:/W2/MedCAT_2026/MedCAT.Cms/pages/chat/index.vue")
  },
  {
    name: "company___vi",
    path: "/company",
    component: () => import("E:/W2/MedCAT_2026/MedCAT.Cms/pages/company/index.vue")
  },
  {
    name: "company___en",
    path: "/en/company",
    component: () => import("E:/W2/MedCAT_2026/MedCAT.Cms/pages/company/index.vue")
  },
  {
    name: "contract-id___vi",
    path: "/contract/:id()",
    component: () => import("E:/W2/MedCAT_2026/MedCAT.Cms/pages/contract/[id].vue")
  },
  {
    name: "contract-id___en",
    path: "/en/contract/:id()",
    component: () => import("E:/W2/MedCAT_2026/MedCAT.Cms/pages/contract/[id].vue")
  },
  {
    name: "contract-document-id___vi",
    path: "/contract/document/:id()",
    component: () => import("E:/W2/MedCAT_2026/MedCAT.Cms/pages/contract/document/[id].vue")
  },
  {
    name: "contract-document-id___en",
    path: "/en/contract/document/:id()",
    component: () => import("E:/W2/MedCAT_2026/MedCAT.Cms/pages/contract/document/[id].vue")
  },
  {
    name: "contract___vi",
    path: "/contract",
    component: () => import("E:/W2/MedCAT_2026/MedCAT.Cms/pages/contract/index.vue")
  },
  {
    name: "contract___en",
    path: "/en/contract",
    component: () => import("E:/W2/MedCAT_2026/MedCAT.Cms/pages/contract/index.vue")
  },
  {
    name: "customer___vi",
    path: "/customer",
    component: () => import("E:/W2/MedCAT_2026/MedCAT.Cms/pages/customer/index.vue")
  },
  {
    name: "customer___en",
    path: "/en/customer",
    component: () => import("E:/W2/MedCAT_2026/MedCAT.Cms/pages/customer/index.vue")
  },
  {
    name: "demo-prescription-dynamic___vi",
    path: "/demo/prescription-dynamic",
    component: () => import("E:/W2/MedCAT_2026/MedCAT.Cms/pages/demo/prescription-dynamic.vue")
  },
  {
    name: "demo-prescription-dynamic___en",
    path: "/en/demo/prescription-dynamic",
    component: () => import("E:/W2/MedCAT_2026/MedCAT.Cms/pages/demo/prescription-dynamic.vue")
  },
  {
    name: "document-pending___vi",
    path: "/document-pending",
    component: () => import("E:/W2/MedCAT_2026/MedCAT.Cms/pages/document-pending/index.vue")
  },
  {
    name: "document-pending___en",
    path: "/en/document-pending",
    component: () => import("E:/W2/MedCAT_2026/MedCAT.Cms/pages/document-pending/index.vue")
  },
  {
    name: "documents___vi",
    path: "/documents",
    component: () => import("E:/W2/MedCAT_2026/MedCAT.Cms/pages/documents/index.vue")
  },
  {
    name: "documents___en",
    path: "/en/documents",
    component: () => import("E:/W2/MedCAT_2026/MedCAT.Cms/pages/documents/index.vue")
  },
  {
    name: "facility___vi",
    path: "/facility",
    component: () => import("E:/W2/MedCAT_2026/MedCAT.Cms/pages/facility/index.vue")
  },
  {
    name: "facility___en",
    path: "/en/facility",
    component: () => import("E:/W2/MedCAT_2026/MedCAT.Cms/pages/facility/index.vue")
  },
  {
    name: "index___vi",
    path: "/",
    component: () => import("E:/W2/MedCAT_2026/MedCAT.Cms/pages/index.vue")
  },
  {
    name: "index___en",
    path: "/en",
    component: () => import("E:/W2/MedCAT_2026/MedCAT.Cms/pages/index.vue")
  },
  {
    name: "original-document___vi",
    path: "/original-document",
    component: () => import("E:/W2/MedCAT_2026/MedCAT.Cms/pages/original-document/index.vue")
  },
  {
    name: "original-document___en",
    path: "/en/original-document",
    component: () => import("E:/W2/MedCAT_2026/MedCAT.Cms/pages/original-document/index.vue")
  },
  {
    name: "payment-request-csyt-id___vi",
    path: "/payment-request/csyt/:id()",
    component: () => import("E:/W2/MedCAT_2026/MedCAT.Cms/pages/payment-request/csyt/[id].vue")
  },
  {
    name: "payment-request-csyt-id___en",
    path: "/en/payment-request/csyt/:id()",
    component: () => import("E:/W2/MedCAT_2026/MedCAT.Cms/pages/payment-request/csyt/[id].vue")
  },
  {
    name: "payment-request-csyt___vi",
    path: "/payment-request/csyt",
    component: () => import("E:/W2/MedCAT_2026/MedCAT.Cms/pages/payment-request/csyt/index.vue")
  },
  {
    name: "payment-request-csyt___en",
    path: "/en/payment-request/csyt",
    component: () => import("E:/W2/MedCAT_2026/MedCAT.Cms/pages/payment-request/csyt/index.vue")
  },
  {
    name: "payment-request-ctbh-id___vi",
    path: "/payment-request/ctbh/:id()",
    component: () => import("E:/W2/MedCAT_2026/MedCAT.Cms/pages/payment-request/ctbh/[id].vue")
  },
  {
    name: "payment-request-ctbh-id___en",
    path: "/en/payment-request/ctbh/:id()",
    component: () => import("E:/W2/MedCAT_2026/MedCAT.Cms/pages/payment-request/ctbh/[id].vue")
  },
  {
    name: "payment-request-ctbh___vi",
    path: "/payment-request/ctbh",
    component: () => import("E:/W2/MedCAT_2026/MedCAT.Cms/pages/payment-request/ctbh/index.vue")
  },
  {
    name: "payment-request-ctbh___en",
    path: "/en/payment-request/ctbh",
    component: () => import("E:/W2/MedCAT_2026/MedCAT.Cms/pages/payment-request/ctbh/index.vue")
  },
  {
    name: "payment-request___vi",
    path: "/payment-request",
    component: () => import("E:/W2/MedCAT_2026/MedCAT.Cms/pages/payment-request/index.vue")
  },
  {
    name: "payment-request___en",
    path: "/en/payment-request",
    component: () => import("E:/W2/MedCAT_2026/MedCAT.Cms/pages/payment-request/index.vue")
  },
  {
    name: "role___vi",
    path: "/role",
    component: () => import("E:/W2/MedCAT_2026/MedCAT.Cms/pages/role/index.vue")
  },
  {
    name: "role___en",
    path: "/en/role",
    component: () => import("E:/W2/MedCAT_2026/MedCAT.Cms/pages/role/index.vue")
  },
  {
    name: "system-config___vi",
    path: "/system-config",
    component: () => import("E:/W2/MedCAT_2026/MedCAT.Cms/pages/system-config/index.vue")
  },
  {
    name: "system-config___en",
    path: "/en/system-config",
    component: () => import("E:/W2/MedCAT_2026/MedCAT.Cms/pages/system-config/index.vue")
  },
  {
    name: "test___vi",
    path: "/test",
    component: () => import("E:/W2/MedCAT_2026/MedCAT.Cms/pages/test.vue"),
    children: [
  {
    name: "test-file-manager___vi",
    path: "file-manager",
    component: () => import("E:/W2/MedCAT_2026/MedCAT.Cms/pages/test/file-manager.vue")
  },
  {
    name: "test-file-viewer___vi",
    path: "file-viewer",
    component: () => import("E:/W2/MedCAT_2026/MedCAT.Cms/pages/test/file-viewer.vue")
  },
  {
    name: "test-pdf2image___vi",
    path: "pdf2image",
    component: () => import("E:/W2/MedCAT_2026/MedCAT.Cms/pages/test/pdf2image.vue")
  }
]
  },
  {
    name: "test___en",
    path: "/en/test",
    component: () => import("E:/W2/MedCAT_2026/MedCAT.Cms/pages/test.vue"),
    children: [
  {
    name: "test-file-manager___en",
    path: "file-manager",
    component: () => import("E:/W2/MedCAT_2026/MedCAT.Cms/pages/test/file-manager.vue")
  },
  {
    name: "test-file-viewer___en",
    path: "file-viewer",
    component: () => import("E:/W2/MedCAT_2026/MedCAT.Cms/pages/test/file-viewer.vue")
  },
  {
    name: "test-pdf2image___en",
    path: "pdf2image",
    component: () => import("E:/W2/MedCAT_2026/MedCAT.Cms/pages/test/pdf2image.vue")
  }
]
  },
  {
    name: "test2___vi",
    path: "/test2",
    component: () => import("E:/W2/MedCAT_2026/MedCAT.Cms/pages/test2.vue")
  },
  {
    name: "test2___en",
    path: "/en/test2",
    component: () => import("E:/W2/MedCAT_2026/MedCAT.Cms/pages/test2.vue")
  },
  {
    name: "user-report-id___vi",
    path: "/user-report/:id()",
    component: () => import("E:/W2/MedCAT_2026/MedCAT.Cms/pages/user-report/[id].vue")
  },
  {
    name: "user-report-id___en",
    path: "/en/user-report/:id()",
    component: () => import("E:/W2/MedCAT_2026/MedCAT.Cms/pages/user-report/[id].vue")
  },
  {
    name: "user-report___vi",
    path: "/user-report",
    component: () => import("E:/W2/MedCAT_2026/MedCAT.Cms/pages/user-report/index.vue")
  },
  {
    name: "user-report___en",
    path: "/en/user-report",
    component: () => import("E:/W2/MedCAT_2026/MedCAT.Cms/pages/user-report/index.vue")
  }
]